// Load SFC Short Interest
export const START_LOAD_SFC_SHORT_INTEREST = 'START_LOAD_SFC_SHORT_INTEREST';
export const LOAD_SFC_SHORT_INTEREST_SUCCESS = 'LOAD_SFC_SHORT_INTEREST_SUCCESS';
export const LOAD_SFC_SHORT_INTEREST_FAILURE = 'LOAD_SFC_SHORT_INTEREST_FAILURE';
export const INIT_LOAD_SFC_SHORT_INTEREST_ACTION_STATUS = 'INIT_LOAD_SFC_SHORT_INTEREST_ACTION_STATUS';